<template>
  <div style="width: 25%;">
    <div style="width:100%  display: flex;" class="item1">
      <span>客资来源负责人钱数</span>
      <div id="item1" style="width:100%; height:400px
      ">
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
  props: {
    list9: Array
  },
  name: "",
  data () {
    return {

    }
  },
  mounted () {
    this.initBie()
  },
  methods: {
    initBie () {
      let chartDom = document.getElementById('item1');
      let myChart = echarts.init(chartDom);
      let option;

      option = {
        color: ['#fac858',
          '#ee6666',
          '#73c0de',
          '#3ba272',
          '#fc8452',
          '#1cbfd7',
          '#00b2de',
          '#9fd7dd',
          '#91afdb',
          '#bc9fb2'
        ],
        title: {
          text: '',
          right: 'center'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          left: 'center'
        },
        series: [
          {
            // name: this.list1.map(item=>{item.name}),
            type: 'pie',
            radius: '50%',
            data: this.list9,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };

      option && myChart.setOption(option);
      window.onresize = function () {
        myChart.resize();
      }
    }
  },
  watch: {
    list9: {
      deep: true,
      handler (val) {
        this.initBie()
      },
    },
  },
  components: {

  },
}
</script>

<style scoped></style>




// WEBPACK FOOTER //
// src/statistics/components/income8.vue